import { TrendingUp, User, Mic, DollarSign } from 'react-feather';
import Avatar from '../../../components/uiElements/avatar';
import { Card, CardHeader, CardTitle, CardBody, CardText, Row, Col } from 'reactstrap';

const StatsCard = ({ cols }) => {
  const data = [
    {
      title: 'Sales',
      target: '230k',
      color: 'light-primary',
      icon: <TrendingUp size={24} />
    },
    {
      title: 'Users',
      target: '8.549k',
      color: 'light-secondary',
      icon: <User size={24} />
    },
    {
      title: 'Voices',
      target: '1.423k',
      color: 'light-danger',
      icon: <Mic size={24} />
    },
    {
      title: 'Revenue',
      target: '$9745',
      color: 'light-success',
      icon: <DollarSign size={24} />
    }
  ];

  const renderData = () => {
    return data.map((item, index) => {
      return (
        <Col key={index} {...cols} className="mb-2">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div className="d-flex align-items-center">
              <Avatar color={item.color} icon={item.icon} className="me-2" />
              <div className="my-auto">
                <h4 className="fw-bolder fs-5 mb-0">{item.title}</h4>
              </div>
            </div>
            <div>
              <CardText className="fw-normal fs-5 mb-0">{item.target}</CardText>
            </div>
          </div>
        </Col>
      );
    });
  };

  return (
    <Card className="card-statistics">
      <CardHeader>
        <CardTitle tag="h4">Statistics</CardTitle>
        <CardText className="card-text font-small-2 me-25 mb-0">Updated 1 month ago</CardText>
      </CardHeader>
      <CardBody className="statistics-body">
        <Row>{renderData()}</Row>
      </CardBody>
    </Card>
  );
};

export default StatsCard;
